// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stem-product-card {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border-radius: 20px;
  margin: 20px 0px;
  height: 570px;
  overflow: hidden;
}

.spc-custom {
  border-radius: 20px;
  border: medium none currentColor;
  border: initial;
}
.spc-content-wrapper {
  padding: 20px 30px;
}

.spc-title-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 5px;
  column-gap: 10px;
}

.spc-title h3 {
  font-size: 22px;
  margin-bottom: 0px;
  text-wrap: nowrap;
  text-transform: capitalize;
}

.spc-title {
  overflow: hidden;
}

.whishlist-icon svg {
  color: var(--dPink);
}

.spc-text-rating-wrapper {
  border-top: 1px solid var(--LGrey);
  border-bottom: 1px solid var(--LGrey);
}

.spc-text-rating-wrapper {
  padding: 10px 0px;
}

.spc-text-rating-wrapper p {
  color: #112f48 !important;
}

.rating-section {
  padding-top: 10%;
}
.buy-price-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.price-wrapper p {
  font-size: 20px;
  margin-bottom: 0;
}

.spc-buy-btn {
  background-color: var(--green);
  border: medium none currentColor;
  border: initial;
  font-weight: 700;
  padding: 5px 30px;
  font-size: 20px;
  color: #000;
}

.price-wrapper {
  text-align: end;
}

.free-cu-btn {
  background-color: var(--dPink);
  color: #ffffff;
  margin-top: 10px;
}

@media (max-width: 767px) {
  .price-wrapper p {
    font-size: 16px;
  }
}

@media (max-width: 576px) {
  .spc-title h3 {
    font-size: 16px;
  }

  .spc-buy-btn {
    padding: 5px 20px;
    font-size: 16px;
  }

  .price-wrapper p {
    font-size: 16px;
  }
}

@media only screen and (min-width: 1080px) and (max-width: 1200px) {
  .spc-content-wrapper {
    padding: 20px 15px;
  }

  .spc-buy-btn {
    padding: 5px 15px;
  }

  .stem-product-card {
    height: 500px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/component/common/cards/StemProductCard.css"],"names":[],"mappings":"AAAA;EACE,4EAA4E;EAC5E,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gCAAa;EAAb,eAAa;AACf;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,gCAAa;EAAb,eAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".stem-product-card {\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n  border-radius: 20px;\n  margin: 20px 0px;\n  height: 570px;\n  overflow: hidden;\n}\n\n.spc-custom {\n  border-radius: 20px;\n  border: unset;\n}\n.spc-content-wrapper {\n  padding: 20px 30px;\n}\n\n.spc-title-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 5px;\n  column-gap: 10px;\n}\n\n.spc-title h3 {\n  font-size: 22px;\n  margin-bottom: 0px;\n  text-wrap: nowrap;\n  text-transform: capitalize;\n}\n\n.spc-title {\n  overflow: hidden;\n}\n\n.whishlist-icon svg {\n  color: var(--dPink);\n}\n\n.spc-text-rating-wrapper {\n  border-top: 1px solid var(--LGrey);\n  border-bottom: 1px solid var(--LGrey);\n}\n\n.spc-text-rating-wrapper {\n  padding: 10px 0px;\n}\n\n.spc-text-rating-wrapper p {\n  color: #112f48 !important;\n}\n\n.rating-section {\n  padding-top: 10%;\n}\n.buy-price-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.price-wrapper p {\n  font-size: 20px;\n  margin-bottom: 0;\n}\n\n.spc-buy-btn {\n  background-color: var(--green);\n  border: unset;\n  font-weight: 700;\n  padding: 5px 30px;\n  font-size: 20px;\n  color: #000;\n}\n\n.price-wrapper {\n  text-align: end;\n}\n\n.free-cu-btn {\n  background-color: var(--dPink);\n  color: #ffffff;\n  margin-top: 10px;\n}\n\n@media (max-width: 767px) {\n  .price-wrapper p {\n    font-size: 16px;\n  }\n}\n\n@media (max-width: 576px) {\n  .spc-title h3 {\n    font-size: 16px;\n  }\n\n  .spc-buy-btn {\n    padding: 5px 20px;\n    font-size: 16px;\n  }\n\n  .price-wrapper p {\n    font-size: 16px;\n  }\n}\n\n@media only screen and (min-width: 1080px) and (max-width: 1200px) {\n  .spc-content-wrapper {\n    padding: 20px 15px;\n  }\n\n  .spc-buy-btn {\n    padding: 5px 15px;\n  }\n\n  .stem-product-card {\n    height: 500px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
